import {
    getLoanRepresentativeExample,
    GetLoanRepresentativeExampleTextOptions,
} from '@mediaingenuity/totallymoney.cardloanutils'

import Box from '@totallymoney/ui/components/Box'
import Row from '@totallymoney/ui/components/Row'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'

import TooltipButton from '@components/TooltipButton'

interface RepresentativeExampleProps {
    isScored: boolean
    item: Omit<
        GetLoanRepresentativeExampleTextOptions,
        'loanAmount' | 'loanTerm'
    >
    loanAmount: number
    loanTerm: number
    onTooltipPress: () => void
    propositionId: string
}

const RepresentativeExample = ({
    item,
    loanAmount,
    loanTerm,
    propositionId,
    isScored,
    onTooltipPress,
}: RepresentativeExampleProps) => (
    <Box>
        <Row space="space10">
            <Text variant="80" weight="bold">
                Representative example
            </Text>

            <TooltipButton
                data-testid="representative-example-tooltip"
                title={`Tooltip icon for representative example - ${propositionId}`}
                aria-label="What is Representative example?"
                color={theme.grey100}
                onPress={onTooltipPress}
            />
        </Row>

        <Text variant="80" color="light">
            {getLoanRepresentativeExample(
                {
                    ...item,
                    loanAmount,
                    loanTerm,
                },
                {
                    isScored,
                }
            )}
        </Text>
    </Box>
)

export default RepresentativeExample
